<template>
	<div class="content-zsy">
		<div class="title-wrap">
			<h3>고로켓고 이용약관</h3>
		</div>
		<div class="terms-content">
            <p>
                본 약관은 ㈜고로켓고(이하 “회사”라 합니다)이 운영하는 “고로켓고(http://goroketgo.com)”(이하“사이트” 또는 “고로켓고”)에서 제공하는 배송대행, 구매대행, 국제운송 및 관련 부가서비스의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
            </p>

            <strong>제1조 (목적)</strong>
            <p>본 약관은 회사가 운영하는 고로켓고에서 제공하는 각종 서비스의 이용조건, 절차, 회사와 이용자 간의 권리·의무 및 책임사항, 기타 필요한 사항을 정함을 목적으로 합니다.</p>

            <strong>제2조 (정의)</strong>
            <p>본 약관에서 사용하는 용어의 뜻은 다음과 같습니다.</p>
            <p>1. <strong>“고로켓고”</strong>란 회사가 배송대행, 구매대행, 국제운송 및 이에 부수하는 서비스를 제공하기 위하여 운영하는 인터넷 웹사이트 및 관련 시스템을 말합니다.</p>
            <p>2. <strong>“이용자”</strong>란 본 약관에 따라 사이트에 접속하여 회사가 제공하는 서비스를 이용하는 회원 및 비회원을 말합니다.</p>
            <p>3. <strong>“회원”</strong>이란 사이트에 회원가입을 하고 본 약관에 동의한 후 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.</p>
            <p>4. <strong>“비회원”</strong>이란 회원가입 없이 사이트가 제공하는 일부 서비스를 이용하는 자를 말합니다.</p>
            <p>5. <strong>“배송대행 서비스”</strong>란 회원이 해외 판매자 또는 해외 쇼핑몰에서 직접 상품을 주문·결제한 후, 해당 상품이 회사의 해외 물류센터에 입고되면 회사가 회원의 신청에 따라 검수, 포장, 국제운송 연계 및 국내 수취처까지의 배송 절차를 유상으로 제공하는 서비스를 말합니다.</p>
            <p>6. <strong>“구매대행 서비스”</strong>란 회원이 해외 상품의 주문 및 결제를 회사에 위임하고, 회사가 회원을 대신하여 해외 판매자 또는 해외 쇼핑몰에서 상품을 구매한 후 배송대행 절차를 통해 회원에게 전달하는 유상 서비스를 말합니다.</p>
            <p>7. <strong>“국제운송 서비스”</strong>란 해외 물류센터에서 출발하여 항공, 해운, 특송, 택배 등 운송수단을 통해 대한민국 또는 회원이 지정한 국가의 수취지까지 상품을 운송하는 서비스를 말합니다.</p>
            <p>8. <strong>“부가서비스”</strong>란 검수, 사진촬영, 재포장, 합배송, 분할배송, 보관, 반품지원, 라벨 제거, 포장보강 등 회사가 별도로 제공하는 유상 또는 무상 서비스를 말합니다.</p>
            <p>9. <strong>“물류센터”</strong>란 회사가 배송대행 및 국제운송 관련 업무를 수행하기 위해 운영하거나 제휴를 통해 사용하는 해외 또는 국내 보관·작업 시설을 말합니다.</p>
            <p>10. <strong>“배송신청서”</strong>란 회원이 주문한 상품의 정보, 수취인 정보, 통관 정보, 운송 방식 및 기타 필요한 사항을 입력하여 회사에 배송대행 또는 관련 서비스를 신청하는 전자문서를 말합니다.</p>
            <p>11. <strong>“개인통관고유부호”</strong>란 대한민국 관세법령에 따라 개인 수입통관 시 필요한 식별부호를 말합니다.</p>
            <p>12. <strong>“사업자통관”</strong>이란 사업자등록번호를 사용하여 사업자 명의로 수입통관을 진행하는 절차를 말합니다.</p>

            <strong>제3조 (약관의 게시 및 효력)</strong>
            <p>1. 회사는 본 약관의 내용을 이용자가 쉽게 확인할 수 있도록 사이트 초기화면 또는 연결화면에 게시합니다.</p>
            <p>2. 회사는 관련 법령을 위반하지 않는 범위 내에서 본 약관을 개정할 수 있습니다.</p>
            <p>3. 회사가 약관을 개정하는 경우에는 적용일자 및 개정사유를 명시하여 적용일 7일 전부터 공지합니다. 다만, 이용자에게 불리한 내용으로 변경하는 경우에는 적용일 30일 전부터 공지하며, 전자우편, 문자, 카카오톡, 사이트 내 메시지 등 적절한 방법으로 개별 통지할 수 있습니다.</p>
            <p>4. 이용자가 개정약관 시행일까지 명시적으로 거부의사를 표시하지 않고 서비스를 계속 이용하는 경우 개정약관에 동의한 것으로 봅니다.</p>

            <strong>제4조 (서비스의 내용)</strong>
            <p>회사가 제공하는 서비스는 다음과 같습니다.</p>
            <p>1. 배송대행 서비스</p>
            <p>2. 구매대행 서비스</p>
            <p>3. 국제 항공·해상 운송 연계 서비스</p>
            <p>4. 합배송, 분할배송, 재포장, 검수 등 부가서비스</p>
            <p>5. 반품, 교환, 재발송 관련 지원 서비스</p>
            <p>6. LCL/FCL 화물운송 관련 지원 서비스</p>
            <p>7. 기타 회사가 정하는 서비스</p>
            <p>회사는 운영상·기술상 필요에 따라 서비스의 일부 또는 전부를 변경할 수 있으며, 이 경우 사전에 공지합니다.</p>

            <strong>제5조 (회원가입)</strong>
            <p>1. 이용자는 회사가 정한 가입양식에 따라 회원정보를 입력하고 본 약관 및 관련 정책에 동의함으로써 회원가입을 신청할 수 있습니다.</p>
            <p>2. 회원가입은 반드시 본인이 직접 신청하여야 하며, 타인의 명의 또는 정보를 도용하여 가입할 수 없습니다.</p>
            <p>3. 미성년자는 법정대리인의 동의를 받아 회원가입 및 서비스 이용을 하여야 하며, 회사는 필요시 동의 여부를 확인할 수 있습니다.</p>
            <p>4. 회사는 다음 각 호의 어느 하나에 해당하는 경우 가입신청을 승인하지 않거나 사후에 회원자격을 제한할 수 있습니다.</p>
            <p>가. 허위정보를 기재한 경우</p>
            <p>나. 타인의 명의 또는 개인정보를 도용한 경우</p>
            <p>다. 미성년자가 법정대리인의 동의 없이 신청한 경우</p>
            <p>라. 과거 회사 서비스 이용 중 약관 위반으로 회원자격이 제한 또는 상실된 이력이 있는 경우</p>
            <p>마. 회사에 대한 미납금, 손해배상채무 등 미이행 채무가 있는 경우</p>
            <p>바. 서비스 운영을 방해하거나 다른 회원의 이용을 현저히 저해할 우려가 있는 경우</p>
            <p>5. 회원은 회원정보에 변경이 있는 경우 지체 없이 이를 수정하여야 하며, 변경정보 미반영으로 발생한 불이익은 회원의 책임으로 합니다.</p>

            <strong>제6조 (회원 탈퇴 및 자격 제한)</strong>
            <p>1. 회원은 언제든지 사이트를 통해 탈퇴를 요청할 수 있습니다.</p>
            <p>2. 회사는 회원의 탈퇴 요청이 있는 경우, 진행 중인 운송·통관·정산·반품 등의 절차가 완료된 후 탈퇴를 처리할 수 있습니다.</p>
            <p>3. 회원이 다음 각 호에 해당하는 경우 회사는 사전 통지 없이 회원자격을 제한, 정지 또는 상실시킬 수 있습니다.</p>
            <p>가. 약관 또는 관련 법령을 위반한 경우</p>
            <p>나. 허위 배송신청, 허위 통관정보 입력 등 부정한 방법으로 서비스를 이용한 경우</p>
            <p>다. 회사 또는 제3자의 권리, 명예, 신용을 침해한 경우</p>
            <p>라. 결제 의무를 상당 기간 이행하지 않은 경우</p>
            <p>마. 폭언, 협박, 업무방해, 허위사실 유포, 악성 게시 등 정상적인 운영을 방해한 경우</p>
            <p>4. 회사가 회원자격을 상실시키는 경우에는 회원등록을 말소할 수 있으며, 필요한 경우 소명기회를 부여할 수 있습니다.</p>

            <strong>제7조 (회원의 의무)</strong>
            <p>1. 회원은 관련 법령, 본 약관, 사이트 이용안내, 공지사항 및 회사가 통지하는 사항을 준수하여야 합니다.</p>
            <p>2. 회원은 다음 각 호의 행위를 하여서는 안 됩니다.</p>
            <p>가. 허위 정보 입력</p>
            <p>나. 타인의 정보 도용</p>
            <p>다. 통관 회피, 면세 회피, 분할배송 강요 등 위법 또는 탈법적 요청</p>
            <p>라. 금지품목, 규제품목 또는 허위 신고물품의 발송 요청</p>
            <p>마. 사이트 게시정보의 무단 변경 또는 훼손</p>
            <p>바. 회사 또는 제3자의 저작권, 상표권 기타 권리 침해</p>
            <p>사. 회사의 정상적인 업무를 방해하는 행위</p>
            <p>아. 공서양속에 반하는 게시 또는 표현행위</p>
            <p>3. 회원은 물품의 품명, 수량, 가격, 재질, 용도, 브랜드, 원산지, 옵션, 트래킹번호, 통관번호, 수취정보 등 통관 및 배송에 필요한 정보를 정확하게 입력하여야 합니다.</p>
            <p>4. 회원은 본인이 주문한 상품이 물류센터에 도착하기 전까지 배송신청서를 작성하고 필요한 정보를 등록하여야 합니다.</p>
            <p>5. 회원은 회사가 요청하는 운송료, 수수료, 보관료, 추가 작업비용, 관부가세 기타 제반 비용을 정해진 기한 내 납부하여야 합니다.</p>
            <p>6. 회원의 귀책사유로 발생한 통관지연, 반송, 폐기, 과태료, 세금, 손해 또는 분쟁에 대한 책임은 회원이 부담합니다.</p>

            <strong>제8조 (개인정보 보호)</strong>
            <p>1. 회사는 이용자의 개인정보를 관련 법령이 정하는 바에 따라 보호합니다.</p>
            <p>2. 개인정보의 수집, 이용, 보관, 제공, 파기 등에 관한 사항은 회사의 개인정보처리방침에 따릅니다.</p>
            <p>3. 회사는 서비스 제공을 위하여 필요한 범위 내에서 배송업체, 통관업체, 결제업체, 제휴업체 등에 회원 정보를 제공할 수 있으며, 구체적인 사항은 개인정보처리방침에 따릅니다.</p>

            <strong>제9조 (서비스 신청)</strong>
            <p>1. 회원은 서비스 신청 시 다음 각 호의 정보를 정확하게 입력하여야 합니다.</p>
            <p>1) 배송대행<br>가. 해외 판매자 또는 쇼핑몰명<br>나. 상품명, 수량, 금액, 옵션, 트래킹번호<br>다. 수취인 성명, 주소, 연락처<br>라. 개인통관고유부호 또는 사업자등록번호 등 통관정보</p>
            <p>2) 구매대행<br>가. 구매 요청 상품의 URL 또는 상품 식별정보<br>나. 수량, 색상, 사이즈 등 선택사항<br>다. 수취인 정보 및 통관정보<br>라. 결제에 필요한 견적 또는 대금지급 정보</p>
            <p>3) LCL/FCL 화물운송<br>가. 화물의 품명, 수량, 규격, 중량, CBM, 포장 형태<br>나. 발송지 및 도착지 정보<br>다. 수취인 상호, 담당자, 이메일, 연락처, 사업자등록정보</p>
            <p>2. 회원이 입력한 정보가 부정확하거나 누락된 경우 회사는 서비스 제공을 거절하거나 지연할 수 있으며, 이로 인해 발생하는 불이익은 회원의 책임으로 합니다.</p>

            <strong>제10조 (계약의 성립)</strong>
            <p>1. 배송대행 서비스 계약은 회원이 배송신청서를 제출하고 회사가 이를 접수한 시점에 성립합니다.</p>
            <p>2. 구매대행 서비스 계약은 회원이 구매요청을 하고 회사가 이를 승인한 후, 회원이 회사가 안내한 대금을 결제한 시점에 성립합니다.</p>
            <p>3. 화물운송 또는 별도 견적이 필요한 서비스는 회사가 견적 또는 진행의사를 표시하고 회원이 이에 동의한 시점에 계약이 성립합니다.</p>
            <p>4. 회사는 다음 각 호의 경우 서비스 신청을 승낙하지 않을 수 있습니다.</p>
            <p>가. 신청 내용에 허위, 누락, 오기가 있는 경우</p>
            <p>나. 법령상 수출입 또는 운송이 금지되는 물품인 경우</p>
            <p>다. 운송, 통관, 안전, 보관상 현저한 위험이 있는 경우</p>
            <p>라. 기술상 또는 운영상 서비스 제공이 현저히 곤란한 경우</p>

            <strong>제11조 (요금, 비용 및 결제)</strong>
            <p>1. 회사의 서비스 요금은 국제운송료, 구매대행 수수료, 부가서비스 요금, 보관료, 재포장비, 반품지원 비용, 기타 실비 등으로 구성됩니다.</p>
            <p>2. 회원은 회사가 정한 방법에 따라 서비스 이용요금을 납부하여야 합니다.</p>
            <p>3. 국제운송 중 발생하는 관세, 부가가치세, 개별소비세, 통관수수료, 검사비용, 국내배송비 및 기타 공과금은 원칙적으로 회원 부담입니다.</p>
            <p>4. 회사는 운임 산정 기준 변경, 실측 중량 또는 부피 차이, 도서산간 추가비, 통관과정의 추가비용, 판매처 가격변동, 환율변동, 반송·재발송 비용 등으로 추가금이 발생하는 경우 회원에게 청구할 수 있습니다.</p>
            <p>5. 회원이 기한 내 요금을 납부하지 않는 경우 회사는 발송 보류, 보관료 부과, 서비스 제한, 물품 처분 등 필요한 조치를 할 수 있습니다.</p>

            <strong>제12조 (검수, 포장 및 발송)</strong>
            <p>1. 회사는 회원의 신청 및 회사 운영기준에 따라 입고, 검수, 포장, 발송 업무를 수행합니다.</p>
            <p>2. 검수는 회사가 정한 기본 검수범위 또는 회원이 선택한 검수 옵션에 한하여 진행되며, 상품의 진품 여부, 성능, 작동, 정밀 수량, 재질, 품질, 제조상 하자까지 보증하는 것은 아닙니다.</p>
            <p>3. 회사가 제공하는 도착사진, 검수사진, 포장사진 등은 참고자료이며 촬영범위 및 촬영각도에 따라 실제와 차이가 있을 수 있습니다.</p>
            <p>4. 포장은 회원이 선택한 옵션 또는 회사의 포장기준에 따라 진행됩니다.</p>
            <p>5. 회사는 안전한 운송을 위해 필요한 경우 회원의 사전 동의 없이 포장상태를 변경하거나 재포장할 수 있습니다.</p>
            <p>6. 회원이 배송승인을 한 경우, 회원은 검수 및 포장 상태를 확인한 것으로 간주되며, 그 이후 발견되는 사항 중 회사의 명백한 귀책사유가 없는 부분은 보상대상에서 제외될 수 있습니다.</p>
            <p>7. 발송시점 및 선적편은 물량, 운송사 사정, 통관상황, 기상, 공휴일, 천재지변 기타 사유에 따라 조정될 수 있습니다.</p>

            <strong>제13조 (보관 및 노데이터 물품)</strong>
            <p>1. 회원은 물품 도착 전까지 배송신청서 및 트래킹번호를 등록하여야 하며, 미등록 상태로 도착한 물품은 노데이터 물품으로 분류될 수 있습니다.</p>
            <p>2. 회사는 노데이터 물품 또는 신청서 미작성 물품을 일정 기간 보관할 수 있으나, 회원 확인이 어려운 경우 책임 범위는 제한됩니다.</p>
            <p>3. 물품 보관기간은 입고일 기준으로 최대 90일로 하며, 회사 정책에 따라 7일 초과 시 보관료가 부과될 수 있습니다.</p>
            <p>4. 사업자회원의 경우 회사가 별도로 정한 기준에 따라 보관료 면제 또는 유예가 적용될 수 있습니다.</p>
            <p>5. 보관기간이 경과한 물품은 회사의 정책에 따라 폐기, 반송, 임의처분 또는 보관료 충당 목적으로 처리될 수 있으며, 이에 따른 비용은 회원이 부담합니다.</p>
            <p>6. 보관기간 경과 이후 발생한 멸실, 훼손, 가치하락 등에 대해 회사는 책임을 지지 않습니다.</p>

            <strong>제14조 (배송, 통관 및 수입 관련 책임)</strong>
            <p>1. 통관에 필요한 품명, 수량, 가격, 재질, 용도, 브랜드, 원산지, 인증 필요 여부 등은 회원이 정확히 제공하여야 합니다.</p>
            <p>2. 회원의 허위신고, 축소신고, 오신고, 브랜드 허위기재, 인증대상 은폐, 금지품목 혼입, 면세한도 회피, 자가사용 목적 위반 등으로 발생하는 모든 민·형사상 책임은 회원에게 있습니다.</p>
            <p>3. 회사는 운송 및 통관 진행을 지원할 수 있으나, 수입신고의 최종 승인 여부, 과세가격 결정, 품목분류, 세율 적용, 검사 여부, 반출 여부 등은 관세당국 및 관계기관의 판단에 따릅니다.</p>
            <p>4. 세관의 검사, 반입보류, 반송, 폐기, 보류창고 이송, 인증요구, 수입요건 미충족 등으로 발생하는 손해와 비용은 회원이 부담합니다.</p>
            <p>5. 개인회원이 자가사용 범위를 벗어나 판매 목적의 수입을 하여 법적 문제가 발생하는 경우 회사는 책임을 지지 않습니다.</p>

            <strong>제15조 (반품, 교환 및 환급)</strong>
            <p>1. 반품 및 교환은 원칙적으로 해당 판매자의 정책 및 해당 국가의 관련 제도에 따릅니다.</p>
            <p>2. 회원의 단순변심, 옵션선택 오류, 사이즈 착오, 색상 착오, 판매자 오배송, 판매자 하자상품 배송, 원상품 하자 등으로 인한 반품 및 교환 비용은 특별한 사정이 없는 한 회원이 부담합니다.</p>
            <p>3. 회사는 회원의 요청에 따라 반품 또는 교환 절차를 지원할 수 있으나, 최종 승인 여부는 판매자 또는 해당 기관의 정책에 따릅니다.</p>
            <p>4. 구매대행 거래에서 품절, 품절취소, 결제취소, 환불 등이 발생한 경우 회사는 판매처 또는 결제처로부터 실제 환급을 받은 후 정산하여 회원에게 환급합니다.</p>
            <p>5. 해외 판매처 가격변동, 환율변동, 해외 배송비 변동 등으로 구매대행 총액에 차이가 발생한 경우 회사는 추가금을 청구하거나 차액을 환급할 수 있습니다.</p>

            <strong>제16조 (취급제한 및 금지물품)</strong>
            <p>1. 회사는 다음 각 호에 해당하는 물품에 대하여 서비스 제공을 거부하거나 반송, 폐기 또는 관계기관 인계를 할 수 있습니다.</p>
            <p>가. 법령상 수출입 또는 운송이 금지되는 물품</p>
            <p>나. 총포, 도검, 폭발물, 가연성 위험물, 독극물, 마약류, 의약품 등 위험물 또는 규제품목</p>
            <p>다. 동물, 식물, 생물체, 냉장·냉동품, 부패성 물품</p>
            <p>라. 현금, 유가증권, 귀금속, 보석류, 고가 미술품 등 고가품</p>
            <p>마. 음란물, 위조상품, 지식재산권 침해 의심물품</p>
            <p>바. 운송·보관에 부적합한 포장 상태의 물품</p>
            <p>사. 허위신고, 축소신고, 분할신고 등 위법 우려가 있는 물품</p>
            <p>아. 기타 회사가 안전·법률·운영상 취급이 부적절하다고 판단하는 물품</p>
            <p>2. 전항에 따른 조치로 발생하는 비용 및 손해는 회원이 부담합니다.</p>
            <p>3. 회사는 경영상 판단에 따라 특정 품목에 대한 서비스 제공을 제한할 수 있습니다.</p>

            <strong>제17조 (서비스 중단 및 제한)</strong>
            <p>1. 회사는 다음 각 호의 사유가 발생한 경우 서비스의 일부 또는 전부를 일시 중단할 수 있습니다.</p>
            <p>가. 시스템 점검, 보수, 교체, 장애</p>
            <p>나. 통신장애 또는 서버장애</p>
            <p>다. 천재지변, 전쟁, 테러, 전염병, 항공·해운 통제 등 불가항력</p>
            <p>라. 제휴업체, 운송업체, 통관업체의 업무중단 또는 서비스 불능</p>
            <p>마. 기타 회사가 정상적인 서비스 제공이 어렵다고 판단하는 경우</p>
            <p>2. 회사는 전항의 사유로 인한 서비스 중단에 대하여 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.</p>

            <strong>제18조 (회사의 책임 및 책임제한)</strong>
            <p>1. 회사는 회사의 고의 또는 중대한 과실로 인하여 회원에게 손해가 발생한 경우 관련 법령에 따라 책임을 부담합니다.</p>
            <p>2. 회사의 손해배상 범위는 특별한 사정이 없는 한 해당 물품의 실제 구매금액과 직접 손해 범위 내로 제한됩니다.</p>
            <p>3. 다음 각 호의 경우 회사는 책임을 지지 않습니다.</p>
            <p>가. 회원이 입력한 정보의 오류 또는 누락으로 인한 손해</p>
            <p>나. 판매자의 오배송, 하자, 품질문제, 정품 여부, 구성품 누락</p>
            <p>다. 국제운송, 국내운송, 세관검사, 공항·항만 작업, 화물취급 과정에서 발생한 파손, 손괴, 멸실, 지연</p>
            <p>라. 천재지변, 불가항력, 전쟁, 파업, 감염병, 항공·해운 지연</p>
            <p>마. 회원이 보관기간을 초과하여 발생한 손해</p>
            <p>바. 회원이 회사의 안내 또는 경고를 무시하고 진행한 경우</p>
            <p>사. 파손위험상품에 대한 별도 포장보강 또는 보험 가입 없이 발생한 손해</p>
            <p>4. 회사는 실제 판매자가 아니므로 상품 자체의 하자, 성능, 진위, 품질, 적합성, 제조물책임에 대하여 보증하지 않습니다.</p>
            <p>5. 회사는 검수서비스를 제공하더라도 전문 감정, 성능시험, 진품감정, 수량보증까지 책임지는 것은 아닙니다.</p>
            <p>6. 회원이 별도 보험에 가입하지 않은 경우, 운송 중 발생한 사고에 대한 보상범위는 해당 운송사 또는 보험사의 기준에 따릅니다.</p>

            <strong>제19조 (통지)</strong>
            <p>1. 회사는 회원에게 다음 방법 중 하나 이상으로 통지할 수 있습니다.</p>
            <p>가. 전자우편<br>나. 문자메시지<br>다. 카카오톡 또는 메신저<br>라. 사이트 내 알림 또는 메시지함<br>마. 기타 회사가 적절하다고 판단하는 방법</p>
            <p>2. 불특정 다수 회원에 대한 통지는 사이트 공지사항 게시로 갈음할 수 있습니다.</p>
            <p>3. 회원이 등록한 연락처의 오류, 미확인, 수신차단 등으로 인해 통지를 받지 못한 경우 그 책임은 회원에게 있습니다.</p>

            <strong>제20조 (분쟁처리)</strong>
            <p>1. 회사는 이용자의 정당한 의견이나 불만을 신속하고 성실하게 처리하기 위해 노력합니다.</p>
            <p>2. 회사와 회원은 분쟁 발생 시 상호 협의하여 해결하도록 노력합니다.</p>
            <p>3. 회사는 분쟁처리 과정에서 필요한 경우 관련 자료 제출을 요청할 수 있으며, 회원은 이에 성실히 협조하여야 합니다.</p>

            <strong>제21조 (준거법 및 관할법원)</strong>
            <p>1. 본 약관의 해석 및 회사와 회원 간 분쟁에 대하여는 대한민국 법령을 적용합니다.</p>
            <p>2. 회사와 회원 간 발생한 소송은 제소 당시 회사 본점 소재지를 관할하는 법원을 전속적 합의관할로 합니다.</p>

            <br>
            <strong>부칙</strong>
            <p>본 약관은 게시일로부터 시행합니다.</p>
            <p>회원은 회원가입시 약관에 동의함으로써 본 약관의 적용을 받습니다.</p>
		</div>
	</div>
</template>

<script>
export default {
    name: 'Terms'
}
</script>

<style scoped>
	.title-wrap {
	    text-align: center;
	    color: var(--frontground-color);
	    margin: 60px 0;
	}
	.title-wrap h3 {
	    font-size: 45px;
	    font-weight: bold;
	}
    .terms-content {
        line-height: 1.8;
        color: #333;
        font-size: 16px;
    }
    .terms-content p {
        margin-bottom: 10px;
    }
    .terms-content strong {
        display: block;
        font-size: 18px;
        margin-top: 20px;
        margin-bottom: 10px;
    }
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			margin: 30px 10px;
		}
	}
</style>